import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MarketsComponent } from '@src/app/features/markets/markets/markets.component';
import { AddMarketComponent } from '@src/app/features/markets/add-market/add-market.component';
import { ViewMarketComponent } from '@app/features/markets/view-market/view-market.component';
import { EditMarketComponent } from '@src/app/features/markets/edit-market/edit-market.component';
import { ManageMarketUsersComponent } from '@src/app/features/markets/manage-market-users/manage-market-users.component';
import { ManageMarketRetailersComponent } from '@src/app/features/markets/manage-market-retailers/manage-market-retailers.component';

const routes: Routes = [
  { path: '', component: MarketsComponent },
  { path: 'add', component: AddMarketComponent },
  { path: ':marketId/edit', component: EditMarketComponent },
  { path: ':marketId/manage-users', component: ManageMarketUsersComponent },
  { path: ':marketId/manage-retailers', component: ManageMarketRetailersComponent },
  { path: ':marketId', component: ViewMarketComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MarketRoutingModule { }
